export const posts = [
  {
    id: "p01",
    slug: "p01",
    title: "某选秀节目组被曝连夜调整赛制，多位现场观众投稿还原录制细节",
    categorySlug: "entertainment",
    excerpt:
      "三位互不相识的现场观众在同一天向本站投稿，描述的流程调整节点高度一致。我们把他们的记录按时间排好后发现，改动其实发生在观众入场之前。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20smartphone%20with%20chat%20bubbles%20and%20a%20magnifying%20glass%2C%20warm%20coral%20red%20and%20golden%20amber%20palette%2C%20minimal%20flat%20design%2C%20cream%20background%2C%20magazine%20cover%20style%2C%20soft%20grain%20texture&width=800&height=600&seq=gg-cover-01&orientation=landscape",
    alt: "选秀节目赛制调整话题的投稿整理配图",
    author: "编辑部 · 阿柑",
    date: "2026-09-08",
    readTime: 6,
    heat: 9860,
    tags: ["选秀赛制", "现场投稿", "时间线"],
    lead: true,
    hot: true,
    blocks: [
      {
        type: "p",
        text: "本站在上周末陆续收到三份来自同一场录制现场的投稿。三位投稿人互不相识，座位分区也不同，但他们描述的关键节点几乎完全一致，这让我们决定把他们的记录合并成一条完整的时间线。",
      },
      { type: "h2", text: "投稿还原的当天时间线" },
      {
        type: "list",
        items: [
          "13:20 观众开始按分区入场，现场公示的流程单显示当晚共录制两轮。",
          "14:05 工作人员口头通知第一轮结束后将加录一场，未提及规则变化。",
          "16:40 第一轮结束，现场更换了舞台侧方的道具箱，观众席禁止拍摄。",
          "18:10 第二轮开始前，主持人重新宣读了与流程单不一致的投票说明。",
        ],
      },
      {
        type: "p",
        text: "值得注意的是，第三位投稿人提供的流程单照片显示，纸张打印时间是录制前一天，也就是说现场公示的版本本身就是旧的。这解释了为什么观众会觉得「临时改了规则」。",
      },
      {
        type: "quote",
        text: "我们不是想证明谁在操作，只是觉得应该让后来看到节目的人知道，录制现场的流程和成片并不是一回事。",
      },
      { type: "h2", text: "目前可以确认与仍待确认的部分" },
      {
        type: "p",
        text: "可以确认的是：现场确实存在流程单与口播说明不一致的情况。仍待确认的是：调整的原因究竟是录制时长超时，还是赛制本身的安排。节目组尚未就此作出公开回应，我们会持续跟进。",
      },
    ],
  },
  {
    id: "p02",
    slug: "p02",
    title: "综艺剪辑争议持续发酵，投稿人称正片流程与现场存在出入",
    categorySlug: "entertainment",
    excerpt:
      "一档正在播出的综艺因为镜头顺序被观众质疑。两位参与录制的投稿人分别整理了「现场实际顺序」和「正片播出顺序」，并标注了五处差异。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20TV%20studio%20spotlight%20and%20clapperboard%2C%20warm%20coral%20and%20amber%20tones%2C%20minimal%20flat%20vector%20style%2C%20cream%20background%2C%20magazine%20cover%20aesthetic%2C%20subtle%20grain&width=800&height=600&seq=gg-cover-02&orientation=landscape",
    alt: "综艺剪辑顺序争议的线索整理配图",
    author: "编辑部 · 小满",
    date: "2026-09-06",
    readTime: 5,
    heat: 7420,
    tags: ["综艺剪辑", "流程对比", "投稿"],
    hot: true,
    blocks: [
      {
        type: "p",
        text: "剪辑本身不是问题，问题在于观众对「发生了什么」产生了明显不同的理解。两位投稿人分别从观众视角和流程记录视角提供了材料，我们做了对齐。",
      },
      { type: "h2", text: "五处被标注的顺序差异" },
      {
        type: "list",
        items: [
          "正片中先出现的投票环节，现场实际发生在互动游戏之后。",
          "一位嘉宾的自我介绍被切分到两段不同的场景里。",
          "现场休息时的补录镜头被剪进了正式比赛段落。",
          "两轮比赛的机位画面存在交叉使用的情况。",
          "结尾的总结镜头实际拍摄于开场之前。",
        ],
      },
      {
        type: "p",
        text: "需要说明的是，为了播出节奏调整顺序是行业内的常规操作。这些差异是否构成「误导」，取决于节目是否在画面上做了相应提示。目前来看，正片并未添加明确的时间标注。",
      },
      {
        type: "quote",
        text: "整理顺序不是为了挑刺，而是希望大家讨论的时候，至少知道自己在讨论哪一个版本。",
      },
    ],
  },
  {
    id: "p03",
    slug: "p03",
    title: "探店博主集体踩点同一家新店，网友整理时间线发现三天内到访",
    categorySlug: "influencer",
    excerpt:
      "一家刚开业两周的餐饮店，短时间内出现了多条风格高度相似的探店视频。投稿人把发布时间、拍摄角度和话术做了简单比对。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20shopping%20bag%20and%20camera%20lens%2C%20warm%20coral%20amber%20palette%2C%20minimal%20flat%20design%2C%20cream%20background%2C%20magazine%20cover%20style%2C%20soft%20grain%20texture&width=800&height=600&seq=gg-cover-03&orientation=landscape",
    alt: "探店博主集中到访同一家门店的线索配图",
    author: "编辑部 · 阿柑",
    date: "2026-09-05",
    readTime: 4,
    heat: 6890,
    tags: ["探店", "内容合作", "时间线"],
    blocks: [
      {
        type: "p",
        text: "投稿人是一位在同城做美食账号的创作者。他注意到，三天内至少有六条探店内容集中提到了同一家新开业的门店。",
      },
      { type: "h2", text: "投稿人整理出的三个共性" },
      {
        type: "list",
        items: [
          "拍摄镜头高度接近，都包含同一张靠窗桌位和同一道招牌菜。",
          "视频发布时间集中在每天 18:00 至 20:00 之间。",
          "文案中出现了相同的三句推荐语，措辞几乎一致。",
        ],
      },
      {
        type: "p",
        text: "这类现象在探店领域并不罕见，通常对应门店的开业推广合作。它的争议点不在于合作本身，而在于内容是否清晰标注了合作属性。",
      },
      {
        type: "quote",
        text: "读者其实不反感合作探店，反感的是把合作讲成偶遇。",
      },
    ],
  },
  {
    id: "p04",
    slug: "p04",
    title: "头部穿搭博主突然清空橱窗，粉丝投稿猜测与品牌合作变动有关",
    categorySlug: "influencer",
    excerpt:
      "一位粉丝数在百万级的穿搭博主在上周四晚清空了橱窗商品，随后两天内掉了一批关注。多位粉丝投稿记录了变动前后的细节。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20spotlight%20on%20a%20film%20reel%2C%20warm%20coral%20and%20gold%20tones%2C%20minimal%20flat%20vector%20design%2C%20cream%20background%2C%20magazine%20cover%20aesthetic%2C%20soft%20grain&width=800&height=600&seq=gg-cover-04&orientation=landscape",
    alt: "穿搭博主橱窗变动的粉丝投稿配图",
    author: "编辑部 · 小满",
    date: "2026-09-03",
    readTime: 4,
    heat: 5310,
    tags: ["账号变动", "橱窗", "粉丝投稿"],
    blocks: [
      {
        type: "p",
        text: "橱窗清空本身可能只是个人调整，但结合时间点，粉丝们产生了更多疑问。我们梳理了投稿中反复出现的几个观察点。",
      },
      { type: "h2", text: "投稿中反复提到的观察" },
      {
        type: "list",
        items: [
          "清空发生在当晚上播之后的半小时内，此前并无预告。",
          "次日发布的日常内容中，此前常出现的合作品牌标识全部消失。",
          "评论区关于橱窗的提问在几小时内被设置为不再可见。",
        ],
      },
      {
        type: "p",
        text: "截至目前，该账号并未就橱窗变动做出说明。合作关系的变动属于正常的商业行为，在没有进一步信息前，任何具体的猜测都还只是猜测。",
      },
    ],
  },
  {
    id: "p05",
    slug: "p05",
    title: "新剧路透造型曝光，剧组工作人员投稿回应造型争议",
    categorySlug: "screens",
    excerpt:
      "一组片场路透在社交平台流传后引发造型讨论。一位自称参与前期筹备的投稿人提供了造型方案的调整过程说明。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20city%20apartment%20building%20and%20elevator%2C%20warm%20coral%20amber%20tones%2C%20minimal%20flat%20style%2C%20cream%20background%2C%20magazine%20cover%20design%2C%20subtle%20grain&width=800&height=600&seq=gg-cover-05&orientation=landscape",
    alt: "剧组造型方案调整的投稿配图",
    author: "编辑部 · 阿柑",
    date: "2026-09-01",
    readTime: 5,
    heat: 6040,
    tags: ["路透", "造型", "剧组投稿"],
    blocks: [
      {
        type: "p",
        text: "路透照片的传播速度往往快过剧组的官方物料，这也让造型讨论常常发生在观众看到完整设定之前。",
      },
      { type: "h2", text: "投稿人给出的造型调整脉络" },
      {
        type: "list",
        items: [
          "初版方案参考的是角色设定里明确写到的时间背景。",
          "开拍前因季节变化对材质做了替换，外观轮廓随之改变。",
          "被拍摄的那组路透属于临时试装，并非最终定妆。",
        ],
      },
      {
        type: "quote",
        text: "造型好看不好看可以讨论，但用试装照去评判成片，对整组人不太公平。",
      },
      {
        type: "p",
        text: "本站无法独立核实该投稿人的剧组身份，相关说法我们只做转述。建议读者以片方后续发布的正式物料为准。",
      },
    ],
  },
  {
    id: "p06",
    slug: "p06",
    title: "电影宣传期两大主演零互动？投稿视频显示后台确有同框",
    categorySlug: "screens",
    excerpt:
      "因为路演现场座位隔得较远，两位主演被传「关系微妙」。一位在场观众投稿的侧拍视频记录了后台候场时的画面。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20product%20boxes%20and%20price%20tags%2C%20warm%20coral%20gold%20palette%2C%20minimal%20flat%20vector%20design%2C%20cream%20background%2C%20magazine%20cover%20style%2C%20soft%20grain&width=800&height=600&seq=gg-cover-06&orientation=landscape",
    alt: "电影路演主创互动线索的整理配图",
    author: "编辑部 · 小满",
    date: "2026-08-29",
    readTime: 3,
    heat: 4780,
    tags: ["路演", "主创互动", "现场视频"],
    blocks: [
      {
        type: "p",
        text: "路演现场的座位排布由主办方决定，并不完全反映主创之间的真实关系。一位观众提供的候场画面，让这条传闻有了更完整的背景。",
      },
      {
        type: "p",
        text: "视频显示，两人在后台候场区相邻站立约两分钟，期间有简短交谈。画面没有声音，也无法判断具体内容。但至少「全程零互动」的说法与这段记录不符。",
      },
      {
        type: "list",
        items: [
          "路演舞台上座位由主办方按宣传顺序安排。",
          "后台候场区画面显示两人存在同框与交谈。",
          "视频来源为观众侧拍，未做剪辑处理。",
        ],
      },
    ],
  },
  {
    id: "p07",
    slug: "p07",
    title: "小区电梯广告更换引热议，业主投稿还原沟通全过程",
    categorySlug: "society",
    excerpt:
      "一个住宅小区的电梯广告位在租约未到期时被更换，业主群里出现了不同说法。一位业主把沟通记录完整地投给了我们。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20timeline%20chart%20and%20speech%20bubbles%2C%20warm%20coral%20amber%20tones%2C%20minimal%20flat%20design%2C%20cream%20background%2C%20magazine%20cover%20aesthetic%2C%20subtle%20grain&width=800&height=600&seq=gg-cover-07&orientation=landscape",
    alt: "小区电梯广告更换沟通过程的投稿配图",
    author: "编辑部 · 阿柑",
    date: "2026-08-26",
    readTime: 5,
    heat: 3960,
    tags: ["社区沟通", "公共空间", "流程"],
    blocks: [
      {
        type: "p",
        text: "公共空间的商业内容往往涉及多方，沟通记录一旦不完整，很容易演变成各说各话。这位业主的投稿价值在于，他把节点都标了出来。",
      },
      { type: "h2", text: "投稿人记录的关键节点" },
      {
        type: "list",
        items: [
          "8 月 12 日 物业在公告栏张贴广告位调整说明，未在业主群同步。",
          "8 月 15 日 有业主在群内询问，物业回复称「属于日常运维」。",
          "8 月 18 日 原广告撤下，新广告上刊，未公示新的收益归属。",
          "8 月 21 日 业主要求查看合同，物业表示需走流程申请。",
        ],
      },
      {
        type: "quote",
        text: "我们不是反对换广告，是想知道换的依据是什么、收益去了哪里。",
      },
      {
        type: "p",
        text: "投稿人表示，目前业主代表已与物业约定下周沟通。本站会继续关注此事的后续进展。",
      },
    ],
  },
  {
    id: "p08",
    slug: "p08",
    title: "景区预约规则调整，多位游客投稿对比新旧流程差异",
    categorySlug: "society",
    excerpt:
      "一个热门景区在本月调整了预约与入园规则。四位游客分别投稿了各自的入园经历，我们对比后排出了新旧流程的不同。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20mountain%20scenic%20spot%20and%20ticket%20gate%2C%20warm%20coral%20gold%20palette%2C%20minimal%20flat%20style%2C%20cream%20background%2C%20magazine%20cover%20design%2C%20soft%20grain&width=800&height=600&seq=gg-cover-08&orientation=landscape",
    alt: "景区预约规则调整的游客投稿配图",
    author: "编辑部 · 小满",
    date: "2026-08-23",
    readTime: 4,
    heat: 3420,
    tags: ["预约规则", "出行", "流程对比"],
    blocks: [
      {
        type: "p",
        text: "规则调整本身是为了分流，但对临时出行的游客来说，信息同步是否及时直接决定了体验。",
      },
      { type: "h2", text: "新旧流程的主要差异" },
      {
        type: "list",
        items: [
          "旧流程：当日现场可补票入园，窗口排队为主。",
          "新流程：需提前一天线上预约，现场仅保留少量应急名额。",
          "新流程增加了分时段入园，超时需重新排队。",
          "退改规则由「随时可退」调整为「提前 4 小时可退」。",
        ],
      },
      {
        type: "p",
        text: "四位投稿人中，有三位表示是在到达景区后才了解到新规则。景区方面已在入口增加了提示牌，但线上渠道的更新相对滞后。",
      },
    ],
  },
  {
    id: "p09",
    slug: "p09",
    title: "某品牌发布会宣传语被指撞梗，投稿整理时间线对比",
    categorySlug: "brand",
    excerpt:
      "一句出现在新品发布会上的宣传语，被网友指出与两年前的一条广告文案高度接近。投稿人把两段文案的发布时间做了对比。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20megaphone%20and%20news%20documents%2C%20warm%20coral%20amber%20tones%2C%20minimal%20flat%20vector%20design%2C%20cream%20background%2C%20magazine%20cover%20style%2C%20soft%20grain&width=800&height=600&seq=gg-cover-09&orientation=landscape",
    alt: "品牌宣传语文案对比的投稿整理配图",
    author: "编辑部 · 阿柑",
    date: "2026-08-20",
    readTime: 4,
    heat: 5120,
    tags: ["品牌营销", "文案", "时间线"],
    hot: true,
    blocks: [
      {
        type: "p",
        text: "文案撞梗的判断往往很主观，但如果连句式结构都接近，就值得拿出来对照一下。投稿人做了一份相当克制的对比表。",
      },
      { type: "h2", text: "两段文案的对照要点" },
      {
        type: "list",
        items: [
          "两段文案的核心短句长度一致，均为九个字。",
          "前后半句的转折结构相同，仅替换了三个名词。",
          "旧文案发布于两年前的社交平台，目前仍可检索。",
        ],
      },
      {
        type: "quote",
        text: "相似不一定等于抄袭，但作为消费者，我想知道这是不是巧合。",
      },
      {
        type: "p",
        text: "品牌方目前未就此作出回应。文案创作的巧合在行业内并不罕见，最终判断仍应以版权方的态度为准。",
      },
    ],
  },
  {
    id: "p10",
    slug: "p10",
    title: "联名款上线三小时售罄，消费者投稿反映补货与退货渠道问题",
    categorySlug: "brand",
    excerpt:
      "一次联名发售在上线三小时内售罄，随后出现大量关于补货时间和退货流程的询问。七位消费者向本站投稿了他们的下单经历。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20night%20city%20skyline%20with%20neon%20signs%2C%20warm%20coral%20gold%20palette%2C%20minimal%20flat%20design%2C%20cream%20background%2C%20magazine%20cover%20aesthetic%2C%20soft%20grain&width=800&height=600&seq=gg-cover-10&orientation=landscape",
    alt: "联名款补货与退货问题的消费者投稿配图",
    author: "编辑部 · 小满",
    date: "2026-08-17",
    readTime: 5,
    heat: 4460,
    tags: ["联名", "补货", "售后"],
    blocks: [
      {
        type: "p",
        text: "限量发售的体验往往取决于信息是否透明。消费者最在意的其实不是买不到，而是不知道自己处在什么位置。",
      },
      { type: "h2", text: "投稿反映出的三类问题" },
      {
        type: "list",
        items: [
          "补货公告发布时间不固定，消费者难以提前准备。",
          "部分订单在支付后显示待确认，超过 48 小时才出结果。",
          "退货入口只在小程序内可见，网页端用户不清楚流程。",
        ],
      },
      {
        type: "p",
        text: "品牌客服在回复中表示补货安排仍在评估。我们建议有相似经历的消费者保留好订单截图与沟通记录，便于后续处理。",
      },
    ],
  },
  {
    id: "p11",
    slug: "p11",
    title: "本周投稿精选：十条被忽略的线索，编辑帮你逐条梳理",
    categorySlug: "picks",
    excerpt:
      "过去一周我们收到了两百多份投稿，其中一些信息密度很高却没有形成话题。编辑部挑出十条做了背景补充与核对结论。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20desk%20with%20sorted%20paper%20notes%20and%20a%20coffee%20cup%2C%20warm%20coral%20amber%20tones%2C%20minimal%20flat%20design%2C%20cream%20background%2C%20magazine%20cover%20style%2C%20soft%20grain&width=800&height=600&seq=gg-cover-11&orientation=landscape",
    alt: "本周投稿精选线索梳理配图",
    author: "编辑部 · 选题组",
    date: "2026-08-15",
    readTime: 8,
    heat: 7280,
    tags: ["投稿精选", "线索梳理", "编辑部"],
    lead: false,
    hot: true,
    blocks: [
      {
        type: "p",
        text: "很多有价值的线索因为没有配图、没有冲突感，就被淹没了。但它们往往比热搜更接近真实。以下是我们本周挑出的十条。",
      },
      { type: "h2", text: "与日常消费相关的三条" },
      {
        type: "list",
        items: [
          "多位读者反映某类预售商品的定金退还未在页面明示，我们已整理出完整说明路径。",
          "一位读者完整记录了优惠券规则的变更过程，时间线清晰值得参考。",
          "三家门店的会员积分规则存在差异，投稿人做了对照表。",
        ],
      },
      { type: "h2", text: "与内容行业相关的四条" },
      {
        type: "list",
        items: [
          "两位创作者投稿说明了同一场活动的结算周期差异。",
          "一位读者整理了某平台推荐机制的公开说明变更记录。",
          "三位投稿人分别记录了同一次线下活动的入场流程。",
          "一位读者提供了内容标注规范在客户端上的呈现差异截图。",
        ],
      },
      { type: "h2", text: "与社区生活相关的三条" },
      {
        type: "list",
        items: [
          "两个小区的公共区域改造流程被完整记录。",
          "一位读者整理了停车位调整前后的沟通节点。",
          "一位读者投稿了物业服务响应时间的连续记录。",
        ],
      },
      {
        type: "quote",
        text: "线索的价值不在于热不热，而在于它能不能被核对。",
      },
    ],
  },
  {
    id: "p12",
    slug: "p12",
    title: "投稿人自述：我是如何把一段模糊视频还原成完整时间线的",
    categorySlug: "picks",
    excerpt:
      "一位长期投稿人分享了他的整理方法：从拍摄时间戳、口播内容到周边环境变化，一步步把两分钟的视频还原成两小时的现场记录。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20magnifying%20glass%20over%20a%20video%20timeline%2C%20warm%20coral%20amber%20palette%2C%20minimal%20flat%20vector%20design%2C%20cream%20background%2C%20magazine%20cover%20aesthetic%2C%20soft%20grain&width=800&height=600&seq=gg-cover-12&orientation=landscape",
    alt: "投稿人整理视频时间线的方法分享配图",
    author: "投稿人 · 老陈",
    date: "2026-08-12",
    readTime: 7,
    heat: 2890,
    tags: ["投稿方法", "时间线", "自述"],
    blocks: [
      {
        type: "p",
        text: "我叫老陈，做投稿三年了。最开始只是随手发些截图，后来发现真正被采用的，永远是那些把过程讲清楚的线索。下面是我总结的一套笨办法。",
      },
      { type: "h2", text: "第一步：先把元信息抄下来" },
      {
        type: "p",
        text: "拍摄时间、设备型号、可能的天气，这些信息不要在脑子里过一遍就算了，一定要写下来。它们会在你最需要排序的时候派上用场。",
      },
      { type: "h2", text: "第二步：找参照物" },
      {
        type: "list",
        items: [
          "画面里出现的指示牌、店铺招牌，通常有固定的营业时间。",
          "光线角度可以粗略估算时间段，尤其是室外素材。",
          "背景音里的广播内容往往带有明确的时间信息。",
        ],
      },
      { type: "h2", text: "第三步：把不确定的地方标出来" },
      {
        type: "quote",
        text: "千万不要为了让时间线看起来完整，就去填补自己也不确定的环节。标注「未知」，反而更容易被编辑部采用。",
      },
      {
        type: "p",
        text: "最后想说，整理线索不是为了证明自己是对的，而是让看到的人能自己判断。这一点想清楚了，投稿就会轻松很多。",
      },
    ],
  },
];